const isProduction = process.env.NODE_ENV === 'production';

const SOCKET_URL = isProduction
	? process.env.REACT_APP_DEPLOYED_SOCKET_URL
	: process.env.REACT_APP_DEVELOPMENT_SOCKET_URL;

const API_URL = isProduction
	? process.env.REACT_APP_DEPLOYED_API_URL
	: process.env.REACT_APP_DEVELOPMENT_API_URL;

const ACTUAL_DOCUMENT_URL = isProduction
	? process.env.REACT_APP_DEPLOYED_ACTUAL_IMAGE
	: process.env.REACT_APP_DEVELOPMENT_ACTUAL_IMAGE;

const COMPRESS_DOCUMENT_URL = isProduction
	? process.env.REACT_APP_DEPLOYED_COMPRESSED_IMAGE
	: process.env.REACT_APP_DEVELOPMENT_COMPRESSED_IMAGE;

const CASHID = isProduction
	? process.env.REACT_APP_DEPLOYED_CASH
	: process.env.REACT_APP_DEVELOPMENT_CASH;

const UPIID = isProduction
	? process.env.REACT_APP_DEPLOYED_UPI
	: process.env.REACT_APP_DEVELOPMENT_UPI;

const MIXID = isProduction
	? process.env.REACT_APP_DEPLOYED_MIX
	: process.env.REACT_APP_DEVELOPMENT_MIX;

const CARDID = isProduction
	? process.env.REACT_APP_DEPLOYED_CARD
	: process.env.REACT_APP_DEVELOPMENT_CARD;

const SALESMANID = isProduction
	? process.env.REACT_APP_DEPLOYED_SALESMANID
	: process.env.REACT_APP_DEVELOPMENT_SALESMANID;

const MIGRATIONSUPPLIER = isProduction
	? process.env.REACT_APP_DEPLOYED_MIGRATION_SUPPLIER
	: process.env.REACT_APP_DEVELOPMENT_MIGRATION_SUPPLIER;

const WAREHOUSELOC = isProduction
	? process.env.REACT_APP_DEPLOYED_WAREHOUSE_LOC
	: process.env.REACT_APP_DEVELOPMENT_WAREHOUSE_LOC;

const token = JSON.parse(localStorage.getItem('token'));

const config = {
	headers: {
		'Content-type': 'application/json',
		Authorization: token,
	},
};

const formConfig = {
	headers: {
		'Content-Type': 'multipart/form-data',
		Authorization: token,
	},
};

module.exports = {
	SOCKET_URL,
	API_URL,
	config,
	formConfig,
	ACTUAL_DOCUMENT_URL,
	COMPRESS_DOCUMENT_URL,
	CASHID,
	UPIID,
	MIXID,
	CARDID,
	SALESMANID,
	MIGRATIONSUPPLIER,
	WAREHOUSELOC,
};
